
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.672 2.977a5.633 5.633 0 011.284 1.932 5.95 5.95 0 010 4.392 5.633 5.633 0 01-1.284 1.932l-9.192 9.12c-.576.576-1.284 1.056-2.124 1.44a7.601 7.601 0 01-2.664.672c-.936.064-1.892-.064-2.868-.384s-1.88-.896-2.712-1.728c-.816-.816-1.384-1.7-1.704-2.652a7.304 7.304 0 01-.384-2.844 7.675 7.675 0 01.66-2.664c.376-.832.852-1.536 1.428-2.112l8.16-8.088c.144-.144.356-.18.636-.108s.492.18.636.324c.128.144.232.356.312.636.08.28.048.492-.096.636l-8.136 8.064a5.766 5.766 0 00-1.08 1.512 4.827 4.827 0 00-.216 3.84c.24.672.672 1.32 1.296 1.944.56.56 1.18.956 1.86 1.188.68.232 1.356.328 2.028.288a5.799 5.799 0 001.92-.444 4.826 4.826 0 001.56-1.032l9.168-9.096c.432-.432.74-.88.924-1.344a3.55 3.55 0 00.264-1.38 3.169 3.169 0 00-.324-1.332 4.387 4.387 0 00-.864-1.2c-.688-.672-1.46-.988-2.316-.948-.856.04-1.716.492-2.58 1.356l-8.28 8.232c-.368.368-.548.776-.54 1.224.008.448.156.816.444 1.104.352.352.756.496 1.212.432.456-.064.828-.24 1.116-.528l7.512-7.464c.144-.144.356-.18.636-.108s.492.18.636.324c.144.144.256.356.336.636.08.28.048.492-.096.636l-7.536 7.464c-.576.576-1.128.976-1.656 1.2-.528.224-1.024.324-1.488.3a2.926 2.926 0 01-1.296-.372 5.473 5.473 0 01-1.104-.816 3.846 3.846 0 01-.732-.984 3.19 3.19 0 01-.372-1.32c-.032-.48.052-.992.252-1.536s.588-1.096 1.164-1.656c.288-.288.544-.552.768-.792.192-.208.372-.392.54-.552l.276-.264 6.696-6.672a6.9 6.9 0 011.884-1.356 5.63 5.63 0 012.076-.564 5.128 5.128 0 012.076.288c.68.24 1.308.648 1.884 1.224z","fill":"#fff"}})])
          )
        }
      }
    